import { api } from "../../common/api";
import { loadPresentations } from "../store/topics";

const doGetTopics = api.path("/api/presentation").method("get").create();

export async function getTopics() {
	try {
		const response = await doGetTopics({});

		const topics = response.data;
		loadPresentations(topics);
	} catch {
		loadPresentations([]);
	}
}
